<div class="page-header">
  <div class="page-title" *ngIf="!isPropertyHome">
    <span>{{ pageTitle | translate }}</span>
    <span *ngIf="itemName" class="page-title-item"> - {{ itemName }}</span>
  </div>
  <div class="page-nav" *ngIf="isPropertyHome">
    <!-- <a routerLink="/">
      <mat-icon fontSet="fal" fontIcon="fa-chevron-left" color="primary"></mat-icon>
    </a>
    <a routerLink="/">
      {{ 'pageHeader.nav.home' | translate }}
    </a>
    <span class="slash-forward">/</span> -->
    <div *ngIf="hideList === 'false'">
      <!-- Absolute on purpose: a relative "../../list" lands one level too deep from a page in a lazy
           module (empty-path child route) and from the deeper property routes (mapping/:section) -->
      <a [routerLink]="['/', lang, 'app', 'properties', 'list']">
        {{ 'pageHeader.nav.properties' | translate }}
      </a>
      <span class="slash-forward">/</span>
    </div>
    <span *ngIf="propertyId === ''">{{ pageTitle | translate }}</span>
    <a [routerLink]="['/', lang, 'app', 'properties', propertyId, 'home']" *ngIf="propertyId">
      {{ pageTitle }}
    </a>
    <a routerLink="../{{propertyId}}/home" *ngIf="propertyId === undefined">
      {{ pageTitle }}
    </a>
  </div>
  <div class="page-toolbar">
    <span class="role-form-label d-none d-md-block">{{ 'pageHeader.chooseRoleLabel' | translate }}:</span>
    <mat-form-field class="role-form-field">
      <mat-select [(ngModel)]="chosenRoleId" (selectionChange)="onRoleChange()" panelClass="role-filter-panel">
        <mat-select-trigger>{{ getRoleDisplayLabel(getChosenRole()) }}</mat-select-trigger>

        <div class="role-filter-header" (click)="$event.stopPropagation()">
          <div class="role-filter-row">
            <mat-icon class="role-filter-icon" fontSet="fal" fontIcon="fa-search"></mat-icon>
            <input
              type="text"
              class="role-filter-input"
              [(ngModel)]="roleTypeSearch"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="applyRoleFilters()"
              (keydown)="$event.stopPropagation()"
              [placeholder]="'pageHeader.roleFilter.searchRoleType' | translate"
              [attr.aria-label]="'pageHeader.roleFilter.searchRoleType' | translate">
            <button
              type="button"
              class="role-filter-sort"
              [class.active]="roleTypeSortDir"
              (click)="toggleRoleTypeSort()"
              [matTooltip]="'pageHeader.roleFilter.sortRoleType' | translate"
              [attr.aria-label]="'pageHeader.roleFilter.sortRoleType' | translate">
              <mat-icon fontSet="fal" [fontIcon]="getSortIcon(roleTypeSortDir)"></mat-icon>
            </button>
          </div>
          <div class="role-filter-row">
            <mat-icon class="role-filter-icon" fontSet="fal" fontIcon="fa-search"></mat-icon>
            <input
              type="text"
              class="role-filter-input"
              [(ngModel)]="companySearch"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="applyRoleFilters()"
              (keydown)="$event.stopPropagation()"
              [placeholder]="'pageHeader.roleFilter.searchCompany' | translate"
              [attr.aria-label]="'pageHeader.roleFilter.searchCompany' | translate">
            <button
              type="button"
              class="role-filter-sort"
              [class.active]="companySortDir"
              (click)="toggleCompanySort()"
              [matTooltip]="'pageHeader.roleFilter.sortCompany' | translate"
              [attr.aria-label]="'pageHeader.roleFilter.sortCompany' | translate">
              <mat-icon fontSet="fal" [fontIcon]="getSortIcon(companySortDir)"></mat-icon>
            </button>
          </div>
        </div>

        <div class="role-filter-empty" *ngIf="displayedUserRoles.length === 0">
          {{ 'pageHeader.roleFilter.noResults' | translate }}
        </div>

        <mat-option *ngFor="let element of displayedUserRoles" [value]="element._id">
          <span *ngIf="element.role.name === 'Admin'">{{ 'roles.types.admin' | translate }}</span>
          <span *ngIf="element.role.name === 'Operator'">{{ 'roles.types.operator' | translate }}</span>
          <span *ngIf="element.role.name === 'Master'">
            {{ 'roles.types.master' | translate }}
            {{ element.company ? ' - ' + element.company.name : '' }}
          </span>
          <span *ngIf="element.role.name === 'Collaborator'">
            {{ 'roles.types.collaborator' | translate }}
            {{ element.company ? ' - ' + element.company.name : '' }}
          </span>
          <span *ngIf="element.role.name === 'Temporary'">
            {{ 'roles.types.temporary' | translate }}
            {{ element.company ? ' - ' + element.company.name : '' }}
          </span>
          <span *ngIf="element.role.name === 'Shared'">
            {{ 'roles.types.shared' | translate }}
            {{ element.company ? ' - ' + element.company.name : '' }}
          </span>
          <small *ngIf="element._id === chosenRoleId">({{ 'pageHeader.currentRole' | translate }})</small>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div> <!-- /.page-toolbar -->
</div> <!-- /.page-header -->
